export const LOG_URL = {
  HIPAY: '/hipay',
  PAY: '/checkout/pay',
  PAYJUNCTION: '/payjunction',
  PAYJUNCTION_FORM: '/checkout/payjunction',
  STRIPE: '/stripe',
  ADYEN: '/adyen',
  BACKEND: 'BACKEND',
  APPLE_QUICK_PAY: '/apple-quick-pay',
};

export const LOG_MSG = {
  AUTH: {
    DISCONNECT: 'Disconnecting user'
  },
  PAYMENT: {
    ERROR: 'Payment error',
    SUCCESS: 'Payment success',
    FORWARDING: 'Payment success (forwarding)',
    STATUS: 'Payment status',
    DECLINED: 'Payment declined'
  },
  REDIRECT: {
    COOKIE: 'Create Cookie after Redirect',
    SUCCESS: 'Redirect from 3DS with success',
    ERROR: 'Redirect from 3DS with error',
    PARAM_ERROR: 'Redirect from 3DS without the right params',
    VALIDATE: 'Cart validation after 3DS redirection',
    BEFORE_VALIDATION: 'Redirect from 3DS - BEFORE validation',
    AFTER_VALIDATION: 'Redirect from 3DS - AFTER validation',
  },
  HIPAY: {
    FORWARDING: 'The user is forwarded to 3ds',
    REFUSED: 'The payment is refused',
    SUCCESS: 'Payment is successful',
    IOBB: {
      LOADED: 'ioBB Loaded',
      ERROR: 'ioBB Error'
    },
    STATE: 'There is a state returned by hipay',
    NO_STATE: 'No state returned by hipay',
    INIT: 'Init hipay loaded',
    FINGERPRINT: 'Fingerprint updated',
    GET_CARD_INFO_SUCCESS: 'Get card info success',
    GET_CARD_INFO_ERROR: 'Get card info error',
    UNKNOWN_STATE: 'Unknown state',
    UPDATE_TOKEN_ERROR: 'HiPay updateToken error'
  },
  ADYEN: {
    SUCCESS: 'Payment is successful',
    FORWARDING: 'The user is forwarded to 3ds',
    REFUSED: 'The payment is refused',
    INIT: 'Init Adyen loaded',
    ERROR: 'Init Adyen Failed !',
    ON_SUBMIT: 'On submit data',
    ON_SUBMIT_ERROR: 'On submit error'
  },
  ADYEN_TWINT: {
    SUCCESS: 'Payment is successful',
    FORWARDING: 'The user is forwarded to 3ds',
    REFUSED: 'The payment is refused',
    INIT: 'Init Adyen twint loaded',
    ERROR: 'Init Adyen twint Failed !',
    ON_SUBMIT: 'On submit data',
    ON_SUBMIT_ERROR: 'On submit error'
  },
  PAYJUNCTION: {
    FORWARDING: 'The user is forwarded to 3ds',
    REFUSED: 'The payment is refused',
    FORM: 'Payjunction form loaded',
    CSR: 'Before CSR Payjunction redirection'
  },
  STRIPE: {
    SESSION_SUCCESS: 'Session success',
    SESSION_ERROR: 'Session error',
    PROMISE_SUCCESS: 'Promise success',
    PROMISE_ERROR: 'Promise error',
    REDIRECT_ERROR: 'Redirect error',
    WRONG_TRANSACTION_CODE: 'Transaction code isn\'t approved',
  },
  MISSING: {
    USER: 'userId is missing',
    STORE: 'storeId is missing',
    CART: 'cartId is missing',
    EXPRO_ORDER: 'exproOrderId is missing'
  },
  APPLEPAY: {
    DATA: 'ApplePay data',
    CONFIGURED: 'ApplePay configured',
    MOUNTED: 'Apple quick pay is mounted',
    AUTHORIZED: 'Payment with apple quick pay is authorized',
    ERROR: 'Error in the apple pay payment'
  }
};
